import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    border: "1px solid #c7c5c5",
  },
  [`&.${tableCellClasses.body}`]: {
    border: "1px solid #c7c5c5",
    fontSize: 16,
    padding: ".2rem 1rem",
  },
}));
function BasicViewTable({ title = null, columns, rows, caption = null }) {
  return (
    <>
      {title && (
        <MDBox mt={2}>
          <MDTypography color="info" variant="h5" mr="2rem">
            {title}
          </MDTypography>
        </MDBox>
      )}

      <TableContainer component={Paper} sx={{ border: "1px solid rgba(0,0,0,.2)", boxShadow: 0 }}>
        <Table stickyHeader>
          {caption && (
            <caption style={{ fontWeight: "bold" }}>{caption ? caption : "Total Quantity"}</caption>
          )}

          <TableHead sx={{ display: "table-header-group" }}>
            <TableRow>
              {columns.map((column, index) => {
                let sx = { minWidth: 150 };

                if (column.left !== undefined) {
                  sx = {
                    ...sx,
                    position: "sticky",
                    left: column.left,
                    minWidth: column.width,
                    zIndex: "21!important",
                  };
                }

                if (column.width !== undefined) {
                  sx = { ...sx, minWidth: column.width };
                }

                return (
                  <StyledTableCell key={index} sx={sx}>
                    {column.headerName}
                  </StyledTableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row, rowIndex) => {
              let background = "white";
              return (
                <TableRow sx={{ background }} key={rowIndex}>
                  {columns.map((column, index) => {
                    let cellValue = row[column.field] ?? "";
                    if (column.valuesGetter) {
                      cellValue = column.valuesGetter(cellValue);
                    }
                    let sx = {
                      padding: "8px 16px",
                      background,
                      borderBottom: "1px solid rgba(224,224,224,1)",
                      borderRight: "1px solid rgba(224,224,224,1)",
                    };
                    if (column.left !== undefined) {
                      sx = {
                        ...sx,
                        position: "sticky",
                        left: column.left,
                        minWidth: column.width,
                        zIndex: 2,
                      };
                      if (column.border) {
                        sx = { ...sx, borderRight: "1px solid rgba(0,0,0,.2)" };
                      }
                    }
                    return (
                      <StyledTableCell
                        onClick={() => {}}
                        sx={sx}
                        key={index}
                        align={column.align ?? "left"}
                      >
                        {cellValue}
                      </StyledTableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default BasicViewTable;
